import ScreenshotImage from './screenshot.png'
import {Link} from "react-router-dom";
import {Helmet} from "react-helmet";

const STEPS = [
    {icon: "bi-input-cursor-text", title: "מזינים את נתוני המשכנתאות", text: "ריביות, סכומים, תקופות והצמדות – בטופס פשוט וברור"},
    {icon: "bi-cpu", title: "מקבלים סימולציה מפורטת", text: "אלפי תרחישים עתידיים מחושבים עבורכם בשיטת מונטה קרלו"},
    {icon: "bi-bar-chart-line", title: "משווים ובוחנים את התמהילים", text: "גרפים ברורים והשוואה בין המסלולים השונים"},
    {icon: "bi-check2-circle", title: "מקבלים החלטות מושכלות", text: "הסבר AI שמסכם עבורכם את היתרונות והחסרונות"},
];

const FEATURES = [
    {icon: "bi-diagram-3", title: "מודלים סטטיסטיים עדכניים", text: "תחזיות מדד מבוססות מודלים שנבנו על נתוני הלמ\"ס"},
    {icon: "bi-shuffle", title: "אלפי תרחישים, לא ניחוש אחד", text: "במקום לנחש מדד יחיד, אנחנו מריצים את כל טווח האפשרויות"},
    {icon: "bi-stars", title: "הסבר מבוסס AI", text: "סיכום מילולי שמדגיש את היתרונות והחסרונות של כל תמהיל"},
];

const PRODUCTS = [
    {
        icon: "bi-bar-chart-steps",
        title: "השוואת משכנתאות",
        text: "מזינים כמה הצעות משכנתא ומקבלים השוואה מבוססת אלפי תרחישים – כדי לבחור את התמהיל המשתלם ביותר עבורכם.",
    },
    {
        icon: "bi-arrow-repeat",
        title: "בדיקת מיחזור משכנתא",
        text: "בודקים אם כדאי למחזר את המשכנתא הקיימת שלכם, ומהו החיסכון הצפוי לאורך חיי ההלוואה.",
    },
    {
        icon: "bi-house-gear",
        title: "בדיקת נכס להשקעה",
        text: "בוחנים את הכדאיות הכלכלית של נכס להשקעה, כולל תרחישי מימון, תשואה והחזרים חודשיים.",
    },
];

function HomePage() {

    return <div className="home-page">
        <Helmet>
            <title> מחשבון משכנתא | משכנתא דאטה </title>
            <meta name="description" content="מחשבון המשכנתא היחיד שמבצע סימולציית מונטה קרלו"/>
            <link rel="icon" href="/favicon.ico" type="image/x-icon"/>
        </Helmet>

        {/* Hero */}
        <section className="home-hero">
            <div className="home-hero-text">
                <span className="home-hero-eyebrow">חינם עכשיו · בקרוב בתשלום</span>
                <h1>לבחור <span className="home-accent">משכנתא</span> עם כלי <span className="home-accent">AI</span>, ולחסוך אלפי שקלים</h1>
                <p>משכנתא דאטה עוזרת לכם לבחור את המשכנתא הטובה ביותר עבורכם, בעזרת סימולטור חכם – תהליך פשוט, תוצאות מהירות.</p>
                <Link to="/login" className="home-cta">
                    <i className="bi bi-arrow-left-circle"></i>
                    אני רוצה להתחיל להשוות
                </Link>
            </div>
            <div className="home-hero-image">
                <img src={ScreenshotImage} alt="דשבורד תרחישים של משכנתא דאטה"/>
            </div>
        </section>

        {/* Products */}
        <section className="home-products-band">
            <div className="home-section-head">
                <h2>שלושה כלים, מטרה אחת – החלטה חכמה יותר</h2>
                <p>בין אם אתם קונים דירה ראשונה, שוקלים מיחזור או בוחנים השקעה – יש לנו כלי בשבילכם</p>
            </div>
            <div className="home-products">
                {PRODUCTS.map((p) => (
                    <div className="home-product" key={p.title}>
                        <div className="home-product-icon"><i className={`bi ${p.icon}`}></i></div>
                        <h3>{p.title}</h3>
                        <p>{p.text}</p>
                        <Link to="/login" className="home-product-link">
                            להתחלה <i className="bi bi-arrow-left"></i>
                        </Link>
                    </div>
                ))}
            </div>
        </section>

        {/* What is it */}
        <section className="home-section">
            <div className="home-section-head">
                <h2>מה זה משכנתא דאטה?</h2>
                <p>
                    ברוכים הבאים למערכת המתקדמת לחישוב החזרי הלוואות ומשכנתאות. מתכננים לקחת הלוואה או רוצים
                    להבין טוב יותר את האפשרויות הפיננסיות שלכם? הכלי מבצע חישובים מתקדמים בהתבסס על מודלים
                    סטטיסטיים עדכניים ותחזיות כלכליות מדויקות.
                </p>
            </div>
            <div className="home-features">
                {FEATURES.map((f) => (
                    <div className="home-feature" key={f.title}>
                        <i className={`bi ${f.icon}`}></i>
                        <h5>{f.title}</h5>
                        <p>{f.text}</p>
                    </div>
                ))}
            </div>
        </section>

        {/* How it works */}
        <section className="home-steps-band">
            <div className="home-section-head">
                <h2>איך זה עובד?</h2>
                <p>תהליך פשוט בארבעה שלבים שיעזור לכם לבחור את המשכנתא המושלמת</p>
            </div>
            <div className="home-steps">
                {STEPS.map((step, i) => (
                    <div className="home-step" key={step.title}>
                        <span className="numbered-badge home-step-badge">{i + 1}</span>
                        <i className={`bi ${step.icon}`}></i>
                        <h5>{step.title}</h5>
                        <p>{step.text}</p>
                    </div>
                ))}
            </div>
        </section>

        {/* Closing CTA */}
        <section className="home-cta-band">
            <div className="home-cta-band-text">
                <h2>ארבעה גרפים, הסבר פשוט</h2>
                <p>בארבעה גרפים פשוטים והסבר מבוסס סוכן AI תקבלו תמונה כוללת של ההצעות שלכם.</p>
                <Link to="/login" className="home-cta">
                    <i className="bi bi-arrow-left-circle"></i>
                    אני רוצה להתחיל להשוות
                </Link>
            </div>
            <div className="home-cta-band-image">
                <img src={ScreenshotImage} alt="תצוגת הגרפים במחשבון"/>
            </div>
        </section>

        {/* Footer */}
        <footer className="home-footer">
            <Link to="/contact">צור קשר</Link>
            <span>משכנתא דאטה | כל הזכויות שמורות 2025</span>
            <a href="https://www.facebook.com/profile.php?id=61574257622616" target="_blank" rel="noopener noreferrer">
                <i className="bi bi-facebook"></i> בקרו אותנו בפייסבוק
            </a>
        </footer>
    </div>;
}

export default HomePage;
